export default "__VITE_ASSET__VHQHAsYY__"